import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarDays } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface Event {
    id: number;
    title: string;
    description: string;
    start_date: string;
    photo?: string;
}

const UpcomingEvents = () => {
    const [events, setEvents] = useState<Event[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get('https://api.ibadansouthanglicandiocese.org.ng/api/v1/upcoming_events')
            .then((res) => {
                const filtered = res.data.events.filter((event: Event) => {
                    return new Date(event.start_date) >= new Date(); // Only future events
                });
                setEvents(filtered);
            })
            .catch((err) => {
                console.error('Failed to fetch events:', err);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Upcoming Events</h2>
                    <p className="text-gray-600 mt-2">Stay informed about our latest activities and gatherings</p>
                </div>

                {loading ? (
                    <div className="text-center text-purple-600 animate-pulse">Loading events...</div>
                ) : events.length === 0 ? (
                    <div className="text-center text-gray-500 py-12">No upcoming events at the moment.</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {events.map((event) => (
                            <Card key={event.id} className="shadow-md hover:shadow-lg transition">
                                <CardContent className="p-0">
                                    {event.photo ? (
                                        <img
                                            src={`https://api.ibadansouthanglicandiocese.org.ng/`+event.photo}
                                            alt={event.title}
                                            className="w-full h-48 object-cover rounded-t"
                                        />
                                    ) : (
                                        <div className="w-full h-48 bg-gray-100 flex items-center justify-center text-gray-400">
                                            📅 No Image
                                        </div>
                                    )}
                                    <div className="p-5 space-y-2">
                                        <h3 className="text-lg font-semibold text-gray-800">{event.title}</h3>
                                        <p className="text-sm text-gray-500 line-clamp-3">{event.description}</p>
                                        <div className="flex items-center gap-2 text-sm text-purple-700 mt-2">
                                            <CalendarDays size={16} />
                                            {new Date(event.start_date).toLocaleDateString('en-US', {
                                                weekday: 'long',
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                            })}
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default UpcomingEvents;
